import { Container, Col, Row } from "reactstrap";
import { BreadcrumbItem } from "reactstrap";
import * as Notify from "@repoflow/form-schema/notify";
import { CancellableContent } from "@repoflow/components/content-cancel";
import {
  Mutation,
  Button,
  useSectionContext,
} from "@repoflow/components/section";
import * as QueriesQL from "queries/site-pack";

export const Sidebar = () => null;

export const Indice = () => (
  <>
    <BreadcrumbItem>Remove</BreadcrumbItem>
  </>
);

export const Content = ({
  history,
  match: {
    params: { siteId, packId },
  },
}) => {
  // `parent` is the packs provider, so its base is the listing — not this
  // pack's own screen, which is about to stop existing. The chain is
  // packs › pack, and Section.Query does not add a level of its own.
  const {
    values,
    parent: { base },
  } = useSectionContext();

  return (
    <CancellableContent>
      <Container className="mt-4">
        <Row>
          <Col>
            Removing the route pack <b>{packId}</b>? Anything under{" "}
            <b>{values.route}</b> goes back to being served by the site's pages.
            The archive itself stays in Documents.
          </Col>
        </Row>
        <Mutation
          mutation={QueriesQL.remove}
          update={QueriesQL.update()}
          onMutate={({ handler }) => {
            handler({
              variables: { siteId, packId },
            });
          }}
          onCompleted={() => {
            history.replace(base);
          }}
          onError={(error) => {
            Notify.error(error.toString());
          }}
        >
          {MutationHandler}
        </Mutation>
      </Container>
    </CancellableContent>
  );
};

const MutationHandler = ({ mutate }) => {
  return (
    <Row>
      <Col>
        <Button
          onClick={() => {
            mutate();
          }}
        >
          Remove
        </Button>
      </Col>
    </Row>
  );
};
